// extracted by mini-css-extract-plugin
export default {"slideItem":"index_slideItem_n2gJf","slides":"index_slides_SE0JK"};